import { render, staticRenderFns } from "./FinancialAccounts.vue?vue&type=template&id=613d36e3"
import script from "./FinancialAccounts.vue?vue&type=script&lang=js"
export * from "./FinancialAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports